import { useAppDispatch } from "@/store/hooks";
import { updateElementProps } from "@/store/slideEditorSlice";
import type { CompositionElement } from "@ai-teach/types";
import { useEffect, useState } from "react";

interface CompositionElementToolbarProps {
  compositionElement: CompositionElement;
}

/**
 * Authoring controls for the composition element: the writing prompt the
 * student sees. Local state + commit-on-blur mirrors SpellingElementToolbar's
 * word input, so every keystroke doesn't churn the undo history.
 */
export function CompositionElementToolbar({ compositionElement }: CompositionElementToolbarProps) {
  const dispatch = useAppDispatch();
  const [localPrompt, setLocalPrompt] = useState(compositionElement.prompt);

  useEffect(() => {
    setLocalPrompt(compositionElement.prompt);
  }, [compositionElement.prompt]);

  const commitPrompt = (value: string) => {
    dispatch(updateElementProps({ id: compositionElement.id, props: { prompt: value } }));
  };

  return (
    <div className="flex items-center gap-1.5">
      <label htmlFor="composition-prompt" className="text-xs font-semibold text-gray-500 uppercase">
        Prompt
      </label>
      <input
        id="composition-prompt"
        type="text"
        value={localPrompt}
        onChange={(e) => setLocalPrompt(e.target.value)}
        onBlur={(e) => commitPrompt(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") (e.target as HTMLInputElement).blur();
        }}
        placeholder="What should the student write about?"
        className="w-72 px-2 py-1 text-sm border text-gray-800 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
  );
}
